enum ActionListBorderEnum {
	none = 'none',
	top = 'top',
	bottom = 'bottom'
}

export default ActionListBorderEnum;
